import { Action, createReducer, on } from '@ngrx/store';
import { BlockTimesProximityActions } from './block-times-proximity.actions';

export const STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY = 'blockTimesAndProximity';

export interface BlockTimesProximityState {
    blockTimes: Array<number>;
    proximity: number;
    isCancelled: boolean;
}

export const initializeBlockTimesProximityState: BlockTimesProximityState = {
    blockTimes: [],
    proximity: 0,
    isCancelled: true
};

const reducer = createReducer(
    initializeBlockTimesProximityState,
    on(BlockTimesProximityActions.updateBlockTimeAndProximity, (state, {blockTimes, proximity, isCancelled}) =>
        ({ ...state,
           blockTimes,
           proximity,
           isCancelled
        }))
);

export function BlockTimesProximityReducer(state: BlockTimesProximityState | undefined, action: Action): BlockTimesProximityState {
    return reducer(state, action);
}
